import React, {Component} from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';

import {Container} from 'reactstrap';
import Header from '../../components/Header/';
import Sidebar from '../../components/Sidebar/';
import Breadcrumb from '../../components/Breadcrumb/';
import Aside from '../../components/Aside/';
import Footer from '../../components/Footer/';

import Dashboard from '../../views/Dashboard/';
import AcademicPage from '../../views/AcademicPage/';
import SettingsPage from '../../views/SettingsPage/';
import StaffPage from '../../views/StaffPage/';
import StudentPage from '../../views/StudentPage/';
import TransportPage from '../../views/TransportPage/';
import HostelPage from '../../views/HostelPage/';
import MessagePage from '../../views/MessagePage/';
import AppPage from '../../views/AppPage/';
import ManagePage from '../../views/ManagePage/';
import ManageStaffPage from '../../views/ManageStaffPage/';
import QuestionPage from '../../views/QuestionPage/';

import Login from '../../views/Pages/Login/';
import Institution from '../../settings/Institution/';
import InstitutionView from '../../settings/InstitutionView/';
import EditInstitution from '../../settings/Institution/EditInstitution';
import Academic from '../../settings/Academic/';
import AcademicUpdate from '../../settings/AcademicUpdate/';
import AssignClass from '../../settings/AssignClass/';
import Caste from '../../settings/Caste/';
import ReligionList from '../../settings/Religion/ReligionList';
import CasteUpdate from '../../settings/Caste/CasteUpdate';
import ReligionUpdate from '../../settings/Religion/ReligionUpdate';
// import Class from '../../academic/Class/';
import EditClass from '../../academic/Class/EditClass';
import Section from '../../academic/Section/';
import EditSection from '../../academic/Section/EditSection';
import AddSection from '../../academic/AddSection/';
import UpdateSection from '../../academic/AddSection/UpdateSection';
import ClassTeacherAllocation from '../../academic/Teacher/ClassTeacherAllocation';
import EditClassTeacherAllocation from '../../academic/Teacher/EditClassTeacherAllocation';
import Subject from '../../subject/Subject/';
import EditSubject from '../../subject/Subject/EditSubject';
import AssignSubject from '../../subject/AssignSubject/';
import EditAssignSubject from '../../subject/AssignSubject/EditAssignSubject';
import SubjectAllocation from '../../subject/SubjectAllocation/';
import EditSubjectAllocation from '../../subject/SubjectAllocation/EditSubjectAllocation';
import ElectiveSubject from '../../subject/ElectiveSubject/';
import LessonPlanning from '../../plan/Lesson/LessonPlanning';
import Usertype from '../../employee/Usertype/';
import Department from '../../employee/Department/';
import Designation from '../../employee/Designation/';
import Employee from '../../employee/Employee/';
import EditEmployee from '../../employee/Employee/EditEmployee';
import EmployeeList from '../../employee/Employee/EmployeeList';
import EmpAttendance from '../../employee/Attendance/EmpAttendance';
import EmpAttendanceView from '../../employee/Attendance/EmpAttendanceView';
import Bank from '../../employee/Bank/';
import PayHead from '../../payroll/PayHead/';
import EditPayHead from '../../payroll/PayHead/EditPayHead';
import PaymentType from '../../payroll/PaymentType/';
import EditPaymentType from '../../payroll/PaymentType/EditPaymentType';
import SalarySettings from '../../payroll/SalarySettings/';
import SalarySettingList from '../../payroll/SalarySettings/SalarySettingList';
import LeaveDeduction from '../../payroll/LeaveDeduction/';
import EditSalarySettings from '../../payroll/SalarySettings/EditSalarySettings';
import Category from '../../leave/Category/';
import EditCategory from '../../leave/Category/EditCategory';
import Details from '../../leave/Details/';
import EditDetails from '../../leave/Details/EditDetails';
import Application from '../../leave/Application/';
import EditApplication from '../../leave/Application/EditApplication';
import StudentCategory from '../../student/StudentCategory/';
import StudentDashboard from '../../student/StudentDashboard/';
import Student from '../../student/Admission/Student';
import StudentList from '../../student/Admission/StudentList';
import TransportStudent from '../../student/TransportStudent';
import PhotoUpload from '../../student/PhotoUpload';
import MobileUpload from '../../student/MobileUpload';
import ViewStudent from '../../student/Admission/ViewStudent';
import EditStudent from '../../student/Admission/EditStudent';
import StudentReport from '../../student/Report/StudentReport';
import CustomReport from '../../student/Report/CustomReport';
import LeaveEntry from '../../student/LeaveEntry/LeaveEntry';
import Attendance from '../../student/Attendance/Attendance';
import AttendanceView from '../../student/Attendance/AttendanceView';
import AttendanceNew from '../../student/Attendance/AttendanceNew';
import AttendanceEdit from '../../student/Attendance/AttendanceEdit';
import Vehicle from '../../transport/Vehicle/';
import EditVehicle from '../../transport/Vehicle/EditVehicle';
import Driver from '../../transport/Driver/';
import EditDriver from '../../transport/Driver/EditDriver';
import Transroute from '../../transport/Transroute/';
import Editroute from '../../transport/Transroute/Editroute';
import Destination from '../../transport/Destination/';
import Allocation from '../../transport/Allocation/';
import Occurrence from '../../occurrence/Occurrence/';
import EditOccurrence from '../../occurrence/Occurrence/EditOccurrence';
import Room from '../../timetable/Room/';
import EditRoom from '../../timetable/Room/EditRoom';
import Printtimetable from '../../timetable/PrintTimeTable/';
import Summary from '../../timetable/Summary/';
import Assignment from '../../assignment/Assignment/';
import EditAssignment from '../../assignment/Assignment/EditAssignment';
import Notes from '../../assignment/Notes/';
import EditNotes from '../../assignment/Notes/EditNotes';
import EventType from '../../events/EventType/';
import AddEvent from '../../events/Event/AddEvent';
import EditEvent from '../../events/Event/EditEvent';
import ViewEvent from '../../events/Event/ViewEvent';
import Events from '../../events/Event/Events';
import EventReport from '../../events/Event/EventReport';
import Circular from '../../circular/Circular/';
import RollNo from '../../student/RollNo/';
import AssignTask from '../../task/AssignTask/';
import TaskDetails from '../../task/AssignTask/TaskDetails';
import ElectiveReport from '../../report/ElectiveReport/';
import SetTerm from '../../exams/SetTerm/';
import Exam from '../../exams/Exam/';
import AnalysisReport from '../../exams/Report/AnalysisReport';
import RankList from '../../exams/Report/RankList';
import RankOrder from '../../exams/Report/RankOrder';


import Daybook from '../../accounts/Daybook/';
import EmployeeSalary from '../../payroll/EmployeeSalary/';
import Loan from '../../payroll/Loan/';
import LoanManage from '../../payroll/Loan/LoanManage';
import Skill from '../../exams/Skill/';
import Grade from '../../exams/Grade/';
import Assessment from '../../exams/Assessment/';
import SetExam from '../../exams/SetExam/';
import EnterMark from '../../exams/Mark/EnterMark';
import EnterMarkStud from '../../exams/Mark/EnterMarkStud';
import Abservation from '../../exams/Abservation';
import ReportCard from '../../exams/ReportCard';
import Hall from '../../examhall/Hall/';
import Invigilator from '../../examhall/Invigilator/';
import SetTimeTable from '../../timetable/SetTimeTable/';
import Group from '../../message/Group/';
import SMSTemplate from '../../message/SMSTemplate/';
import SMSSetup from '../../message/SMSSetup/';
import GreetingSMS from '../../message/GreetingSMS/';
import Report from '../../message/Report/';
import SMSlog from '../../message/SMSlog/';

import Type from '../../certificate/Type/';
import Transfer from '../../certificate/Transfer/';
import EditTransfer from '../../certificate/Transfer/EditTransfer';
import ViewTransfer from '../../certificate/Transfer/ViewTransfer';
import Bonafide from '../../certificate/Bonafidecert/';

import AddUser from '../../users/AllUser/AddUser';
import EditUser from '../../users/AllUser/EditUser';
import AllUser from '../../users/AllUser';

import AddPage from '../../page/Pages/AddPage';
import EditPage from '../../page/Pages/EditPage';
import Pages from '../../page/Pages/Pages';

import Promotion from '../../Promotion/';
import EditPromotion from '../../Promotion/EditPromotion';
import Announcements from '../../Announcements/';

import Homework from '../../homework/';
import HomeWorkManage from '../../homework/manage';
import Mobilelevreq from '../../leave/mobilereq/';
import VersionSetup from '../../app/VersionSetup/';
import MenuSetup from '../../app/MenuSetup/';

import AddGroup from '../../group/AddGroup/AddGroup';
import AddGroupMember from '../../group/AddGroupMember/AddGroupMember';
import ListGroupMember from '../../group/AddGroupMember/ListGroupMember';
import GroupSummary from '../../group/AddGroupMember/GroupSummary';

import HostelList from '../../hostel/HostelList/HostelList';
import Floor from '../../hostel/HostelList/floors';
import Rooms from '../../hostel/HostelList/rooms';
import Admission from '../../hostel/HostelList/admission';
import Hostellers from '../../hostel/HostelList/hostellers';

import Gallery from '../../Gallery';
import Slider from '../../Slider';

//Quiz
import Books from '../../Questions/Books';
import Lesson from '../../Questions/Lesson';
import Questions from '../../Questions/Questions';
import SetupQuestions from '../../Questions/SetupQuestions';
import AddSetupQuestion from '../../Questions/AddSetupQuestion';
import EditSetupQuestion from '../../Questions/EditSetupQuestion';
import ExamList from '../../Questions/ExamList';
import ExamSetup from '../../Questions/ExamSetup';
import ExamResult from '../../Questions/ExamResult';
import DemoExam from '../../Questions/DemoExam';

const ProgressBar = require('react-progress-bar-plus');
require('react-progress-bar-plus/lib/progress-bar.css');

class Full extends Component {
	
  render() {
	
	let userRole = '';
	if(sessionStorage.getItem('isLogged') === 'yes'){
		let userData = JSON.parse(sessionStorage.getItem('userData'));
		userRole = userData['userrole'];
	}
	
    return (
	
      <div className="app">
	  <Header/>
	  
        <div className="app-body">
          <Sidebar {...this.props}/>
          <main className="main">
            <Breadcrumb/>
            <Container fluid>
			<ProgressBar percent={100}/>
              <Switch>
				<Route path="/login" name="Login" component={Login}/>

				{userRole == 'markentry' ?
				<React.Fragment>
					<Route path="/academic/page" name="AcademicPage" component={AcademicPage}/>
					<Route path="/academic/exams/markentry" name="EnterMark" component={EnterMark}/>
					<Route path="/academic/exams/markentrystud" name="EnterMarkStud" component={EnterMarkStud}/>
				</React.Fragment> :
				userRole == 'classteacher' ?
				<React.Fragment>
				
					<Route path="/student/page" name="StudentPage" component={StudentPage}/>
					<Route path="/student/attendanceview" name="View Attendance" component={AttendanceView}/>
					<Route path="/student/attendancenew" name="AttendanceNew" component={AttendanceNew}/>
					<Route path="/student/attendanceedit" name="AttendanceEdit" component={AttendanceEdit}/>
					
					<Route path="/academic/page" name="AcademicPage" component={AcademicPage}/>
					<Route path="/academic/exams/markentry" name="EnterMark" component={EnterMark}/>
					<Route path="/academic/exams/markentrystud" name="EnterMarkStud" component={EnterMarkStud}/>
					<Route path="/academic/exams/observation" name="Abservation" component={Abservation}/>
					<Route path="/academic/exams/reportcard" name="ReportCard" component={ReportCard}/>
					<Route path="/academic/exams/analysisreport" name="AnalysisReport" component={AnalysisReport}/>
					<Route path="/academic/exams/ranklist" name="RankList" component={RankList}/>
					<Route path="/academic/exams/rankorder" name="RankOrder" component={RankOrder}/>
				</React.Fragment> :
				userRole !='' ?
				<React.Fragment>
					<Route path="/academic/page" name="AcademicPage" component={AcademicPage}/>
					<Route path="/settings/page" name="SettingsPage" component={SettingsPage}/>
					<Route path="/staff/page" name="StaffPage" component={StaffPage}/>
					<Route path="/student/page" name="StudentPage" component={StudentPage}/>
					<Route path="/transport/page" name="TransportPage" component={TransportPage}/>
					<Route path="/hostel/page" name="HostelPage" component={HostelPage}/>
					<Route path="/message/page" name="MessagePage" component={MessagePage}/>
					<Route path="/app/page" name="AppPage" component={AppPage}/>
					<Route path="/manage/page" name="ManagePage" component={ManagePage}/>
					<Route path="/manage/staffpage" name="ManageStaffPage" component={ManageStaffPage}/>
					<Route path="/question/page" name="QuestionPage" component={QuestionPage} />
					
					<Route path="/dashboard" name="Dashboard" component={Dashboard}/>
					
					<Route path="/settings/institution" name="Institution" component={Institution}/>
					<Route path="/settings/institutionview" name="InstitutionView" component={InstitutionView}/>
					<Route path="/settings/editinstitution" name="EditInstitution" component={EditInstitution}/>
					<Route path="/settings/academic" name="Academic" component={Academic}/>
					<Route path="/settings/academicupdate/:id" name="AcademicUpdate" component={AcademicUpdate}/>
					<Route path="/settings/assignclass" name="AssignClass" component={AssignClass}/>
					<Route path="/settings/caste" name="Caste" component={Caste}/>
					<Route path="/settings/religion" name="Religion" component={ReligionList}/>
					<Route path="/settings/casteupdate/:id" name="CasteUpdate" component={CasteUpdate}/>
					<Route path="/settings/religionupdate/:id" name="ReligionUpdate" component={ReligionUpdate}/>
					
					<Route path="/academic/editclass/:id" name="EditClass" component={EditClass}/>
					<Route path="/academic/section" name="Section" component={Section}/>
					<Route path="/academic/editsection/:id" name="EditSection" component={EditSection}/>
					<Route path="/academic/class/addsection" name="AddSection" component={AddSection}/>
					<Route path="/academic/updatesection/:id" name="UpdateSection" component={UpdateSection}/>
					<Route path="/academic/class/classteacherallocate" name="ClassTeacherAllocation" component={ClassTeacherAllocation}/>
					<Route path="/academic/editteacherallocate/:id" name="EditClassTeacherAllocation" component={EditClassTeacherAllocation}/>
					<Route path="/academic/subject/subject/" name="Subject" component={Subject}/>
					<Route path="/academic/subject/subjectupdate/:id" name="EditSubject" component={EditSubject}/>
					<Route path="/academic/subject/assignsubject/" name="AssignSubject" component={AssignSubject}/>
					<Route path="/academic/subject/assignsubjectupdate/:id" name="EditAssignSubject" component={EditAssignSubject}/>
					<Route path="/academic/subject/subjectallocate/" name="SubjectAllocation" component={SubjectAllocation}/>
					
					<Route path="/subject/editsubjectallocate/:id" name="EditSubjectAllocation" component={EditSubjectAllocation}/>
					<Route path="/subject/electivesubject/" name="ElectiveSubject" component={ElectiveSubject}/>
					
					<Route path="/plan/lesson/" name="LessonPlanning" component={LessonPlanning}/>
					
					<Route path="/employee/usertype" name="Usertype" component={Usertype}/>
					<Route path="/employee/department" name="Department" component={Department}/>
					<Route path="/employee/designation" name="Designation" component={Designation}/>
					<Route path="/employee/employee" name="Employee" component={Employee}/>
					<Route path="/employee/editemployee/:id" name="EditEmployee" component={EditEmployee}/>
					<Route path="/employee/list" name="EmployeeList" component={EmployeeList}/>
					<Route path="/employee/attendance" name="EmpAttendance" component={EmpAttendance}/>
					<Route path="/employee/attendanceview" name="EmpAttendanceView" component={EmpAttendanceView}/>
					<Route path="/employee/bank" name="Bank" component={Bank}/>
					<Route path="/employee/payroll/payhead" name="PayHead" component={PayHead}/>
					<Route path="/employee/payroll/editpayhead/:id" name="EditPayHead" component={EditPayHead}/>
					<Route path="/payroll/paytype" name="PaymentType" component={PaymentType}/>
					<Route path="/payroll/editpaytype/:id" name="EditPaymentType" component={EditPaymentType}/>
					<Route path="/employee/payroll/salarysetting" name="SalarySettings" component={SalarySettings}/>
					<Route path="/employee/payroll/salsetlist" name="SalarySettingList" component={SalarySettingList}/>
					<Route path="/employee/payroll/editsalarysetting/:id" name="EditSalarySettings" component={EditSalarySettings}/>
					<Route path="/employee/payroll/leavededuct" name="LeaveDeduction" component={LeaveDeduction}/>
					
					<Route path="/leave/category" name="Category" component={Category}/>
					<Route path="/leave/editcategory/:id" name="EditCategory" component={EditCategory}/>
					<Route path="/leave/detail" name="Details" component={Details}/>
					<Route path="/leave/editdetail/:id" name="EditDetails" component={EditDetails}/>
					<Route path="/leave/app" name="Application" component={Application}/>
					<Route path="/leave/editapp/:id" name="EditApplication" component={EditApplication}/>
					
					<Route path="/student/category" name="StudentCategory" component={StudentCategory}/>
					<Route path="/student/admission" name="Student" component={Student}/>
					<Route path="/student/list" name="StudentList" component={StudentList}/>
					<Route path="/student/transport" name="TransportStudent" component={TransportStudent}/>
					<Route path="/student/photoupload" name="PhotoUpload" component={PhotoUpload}/>
					<Route path="/student/mobileupload" name="MobileUpload" component={MobileUpload}/>
					<Route path="/student/view/:ac/:id" name="ViewStudent" component={ViewStudent}/>
					<Route path="/student/edit/:ac/:id" name="EditStudent" component={EditStudent}/>
					<Route path="/student/report" name="StudentReport" component={StudentReport}/>
					<Route path="/student/customreport" name="CustomReport" component={CustomReport}/>
					<Route path="/student/leaveentry" name="LeaveEntry" component={LeaveEntry}/>
					<Route path="/student/leaverequests" name="LeaveRequests" component={Mobilelevreq}/>
					<Route path="/student/attendance" name="Attendance" component={Attendance}/>
					<Route path="/student/dashboard" name="StudentDashboard" component={StudentDashboard}/>
					
					<Route path="/student/attendanceview" name="View Attendance" component={AttendanceView}/>
					<Route path="/student/attendancenew" name="AttendanceNew" component={AttendanceNew}/>
					<Route path="/student/attendanceedit" name="AttendanceEdit" component={AttendanceEdit}/>
					
					<Route path="/transport/vehicle" name="Vehicle" component={Vehicle}/>
					<Route path="/transport/editvehicle/:id" name="EditVehicle" component={EditVehicle}/>
					<Route path="/transport/driver" name="Driver" component={Driver}/>
					<Route path="/transport/editdriver/:id" name="EditDriver" component={EditDriver}/>
					<Route path="/transport/transroute" name="Transroute" component={Transroute}/>
					<Route path="/transport/editroute/:id" name="Editroute" component={Editroute}/>
					<Route path="/transport/destination" name="Destination" component={Destination}/>
					<Route path="/transport/allocate" name="Allocation" component={Allocation}/>
					
					<Route path="/academic/occurrence/register" name="Occurrence" component={Occurrence}/>
					<Route path="/academic/occurrence/editoccurrence/:id" name="EditOccurrence" component={EditOccurrence}/>
					
					<Route path="/timetable/room" name="Room" component={Room}/>
					<Route path="/timetable/editroom/:id" name="EditRoom" component={EditRoom}/>
					
					<Route path="/academic/assignment/add" name="Assignment" component={Assignment}/>
					<Route path="/academic/assignment/editass/:id" name="EditAssignment" component={EditAssignment}/>
					<Route path="/academic/assignment/addnotes" name="Notes" component={Notes}/>
					<Route path="/academic/assignment/editnotes/:id" name="EditNotes" component={EditNotes}/>
					
					<Route path="/events/addtype" name="EventType" component={EventType}/>
					<Route path="/events/addevent" name="AddEvent" component={AddEvent}/>
					<Route path="/events/editevent/:id" name="EditEvent" component={EditEvent}/>
					<Route path="/events/viewevent/:id" name="ViewEvent" component={ViewEvent}/>
					<Route path="/events/event" name="Events" component={Events}/>
					<Route path="/events/eventreport" name="EventReport" component={EventReport}/>
					
					<Route path="/academic/circular/add" name="Circular" component={Circular}/>
					<Route path="/student/rollno" name="RollNo" component={RollNo}/>
					<Route path="/task/addtask" name="AssignTask" component={AssignTask}/>
					<Route path="/task/list" name="TaskDetails" component={TaskDetails}/>
					<Route path="/report/elective" name="ElectiveReport" component={ElectiveReport}/>
					<Route path="/exams/setterm" name="SetTerm" component={SetTerm}/>
					<Route path="/academic/exams/exam" name="Exam" component={Exam}/>
					<Route path="/academic/exams/analysisreport" name="AnalysisReport" component={AnalysisReport}/>
					<Route path="/academic/exams/ranklist" name="RankList" component={RankList}/>
					<Route path="/academic/exams/rankorder" name="RankOrder" component={RankOrder}/>
					
					
					<Route path="/accounts/daybook" name="Daybook" component={Daybook}/>
					
					<Route path="/employee/payroll/salary" name="EmployeeSalary" component={EmployeeSalary}/>
					<Route path="/employee/payroll/loans" name="Loan" component={Loan}/>
					<Route path="/employee/payroll/loanmanage" name="LoanManage" component={LoanManage}/>
					<Route path="/exams/skill" name="Skill" component={Skill}/>
					
					<Route path="/academic/exams/grade" name="Grade" component={Grade}/>
					<Route path="/exams/assessment" name="Assessment" component={Assessment}/>
					<Route path="/academic/exams/setexam" name="SetExam" component={SetExam}/>
					<Route path="/academic/exams/markentry" name="EnterMark" component={EnterMark}/>
					<Route path="/academic/exams/markentrystud" name="EnterMarkStud" component={EnterMarkStud}/>
					<Route path="/academic/exams/observation" name="Abservation" component={Abservation}/>
					<Route path="/academic/exams/reportcard" name="ReportCard" component={ReportCard}/>
					<Route path="/examhall/examhall" name="Hall" component={Hall}/>
					<Route path="/examhall/inviligator" name="Invigilator" component={Invigilator}/>
					<Route path="/academic/timetable/create" name="SetTimeTable" component={SetTimeTable}/>
					<Route path="/academic/timetable/print" name="SetTimeTable" component={Printtimetable}/>
					<Route path="/academic/timetable/summary" name="SetTimeTable" component={Summary}/>
					
					<Route path="/message/group" name="GroupSMS" component={Group}/>
					<Route path="/message/template" name="SMSTemplate" component={SMSTemplate}/>
					<Route path="/message/setup" name="SMSSetup" component={SMSSetup}/>
					<Route path="/message/greetings" name="GreetingSMS" component={GreetingSMS}/>
					<Route path="/message/report" name="SMSReport" component={Report}/>
					<Route path="/message/SMSlog" name="SMSlog" component={SMSlog}/>
					
					<Route path="/app/VersionSetup" name="VersionSetup" component={VersionSetup}/>
					<Route path="/app/MenuSetup" name="MenuSetup" component={MenuSetup}/>
					
					<Route path="/academic/certificate/type" name="Type" component={Type}/>
					<Route path="/academic/certificate/transfer" name="Transfer" component={Transfer}/>
					<Route path="/academic/certificate/edittransfer/:id" name="EditTransfer" component={EditTransfer}/>
					<Route path="/academic/certificate/viewtransfer/:id" name="ViewTransfer" component={ViewTransfer}/>
					<Route path="/academic/certificate/bonafide" name="Bonafide" component={Bonafide}/>
					
					<Route path="/users/adduser" name="AddUser" component={AddUser}/>
					<Route path="/users/edituser/:id" name="EditUser" component={EditUser}/>
					<Route path="/users/alluser" name="AllUser" component={AllUser}/>
					
					<Route path="/page/addpage" name="AddPage" component={AddPage}/>
					<Route path="/page/editpage/:id" name="EditPage" component={EditPage}/>
					<Route path="/page/allpage" name="Pages" component={Pages}/>
					
					<Route path="/announcements" name="Announcements" component={Announcements}/>
					<Route path="/homework/assign" name="HomeWork" component={Homework}/>
					<Route path="/homework/manage" name="HomeWorkManage" component={HomeWorkManage}/>
					<Route path="/editpromote" name="EditPromotion" component={EditPromotion}/>
					<Route path="/promote" name="Promotion" component={Promotion}/>

					<Route path="/group/groups" name="AddGroup" component={AddGroup}/>
					<Route path="/group/members/:id" name="AddGroupMember" component={AddGroupMember}/>
					<Route path="/group/listmember/:id" name="ListGroupMember" component={ListGroupMember}/>
					<Route path="/group/summary" name="GroupSummary" component={GroupSummary}/>

					<Route path="/hostel/hostellist" name="HostelList" component={HostelList}/>
					<Route path="/hostel/rooms" name="Rooms" component={Rooms}/>
					<Route path="/hostel/floors" name="Floor" component={Floor}/>
					<Route path="/hostel/admission" name="Admission" component={Admission}/>
					<Route path="/hostel/hostellers" name="Hostellers" component={Hostellers}/>
					
					<Route path="/gallery" name="Gallery" component={Gallery} />
					<Route path="/slider" name="Slider" component={Slider} />
					
					<Route path="/books" name="Books" component={Books} />
					<Route path="/lesson" name="Lesson" component={Lesson} />
					<Route path="/questions/list" name="Questions" component={Questions} />
					<Route path="/questions/setup" name="SetupQuestions" component={SetupQuestions} />
					<Route path="/questions/addsetup" name="AddSetupQuestion" component={AddSetupQuestion} />
					<Route path="/questions/editsetup/:id" name="EditSetupQuestion" component={EditSetupQuestion} />
					<Route path="/questions/exams" name="ExamList" component={ExamList} />
					<Route path="/questions/examsetup" name="ExamSetup" component={ExamSetup} />
					<Route path="/questions/examresult" name="ExamResult" component={ExamResult} />
					<Route path="/questions/demoexam" name="DemoExam" component={DemoExam} />
				</React.Fragment> : ''
				}
                <Redirect from="/" to="/login"/>
              </Switch>
            </Container>
          </main>
          <Aside/>
        </div>
        <Footer/>
      </div>
	 
    );
  }
}

export default Full;


// WEBPACK FOOTER //
// ./src/containers/Full/Full.js